import React, { useEffect, useState } from "react";
import { ZoomMtg } from "@zoom/meetingsdk";
import { KJUR } from "jsrsasign";
import "./ZoomWebinar.css";

// Import Zoom Meeting SDK CSS
// import "@zoom/meetingsdk/dist/css/bootstrap.css";
// import "@zoom/meetingsdk/dist/css/react-select.css";

// ZoomMtg.setZoomJSLib("https://source.zoom.us/2.13.0/lib", "/av");
ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();
ZoomMtg.i18n.load("en-US");
ZoomMtg.i18n.reload("en-US");

const generateSignature = (meetingNumber, role) => {
  const iat = Math.floor(Date.now() / 1000);
  const exp = iat + 60 * 60 * 2; // Token valid for 2 hours
  const oHeader = { alg: "HS256", typ: "JWT" };

  const oPayload = {
    appKey: "30bMIrGJQuCpZxUVEx9mYA", // Replace with your SDK key
    sdkKey: "30bMIrGJQuCpZxUVEx9mYA", // Replace with your SDK key
    mn: meetingNumber,
    role: role,
    iat: iat,
    exp: exp,
    tokenExp: exp,
  };

  const sHeader = JSON.stringify(oHeader);
  const sPayload = JSON.stringify(oPayload);
  const sdkJWT = KJUR.jws.JWS.sign(
    "HS256",
    sHeader,
    sPayload,
    "YOUR_SDK_SECRET" // Replace with your SDK secret
  );

  console.log("Generated Signature:", sdkJWT);
  return sdkJWT;
};

const ZoomWebinar = ({ userName }) => {
  const [isJoining, setIsJoining] = useState(false);
  const [isJoined, setIsJoined] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name.trim()) {
      joinWebinar(formData.name, formData.email, formData.phone);
    }
  };

  const joinWebinar = async (name = userName, email, phoneNumber) => {
    if (isJoining) return;

    try {
      setIsJoining(true);
      setError(null);

      console.log("Joining webinar with details:", {
        name,
        email,
        phoneNumber,
      });

      const meetingNumber = "YOUR_MEETING_NUMBER"; // Replace with your meeting number
      const role = 0; // Role 0 for joining a webinar

      const signature = generateSignature(meetingNumber, role);

      document.getElementById("zmmtg-root").style.display = "block";

      // Initialize Zoom
      ZoomMtg.init({
        leaveUrl: window.location.origin,
        disablePreview: false,
        webEndpoint: "https://zoom.us",
        success: () => {
          console.log("Zoom SDK initialized successfully");
          ZoomMtg.join({
            signature: signature,
            meetingNumber: meetingNumber,
            userName: name,
            sdkKey: "30bMIrGJQuCpZxUVEx9mYA", // Replace with your SDK key
            passWord: "", // Replace with your webinar password if required
            userEmail: email,
            success: () => {
              console.log("Joined webinar successfully");
              setIsJoined(true);
              setIsJoining(false);
            },
            error: (err) => {
              console.error("Error joining webinar:", err);
              setError("Failed to join webinar. Please try again.");
              setIsJoining(false);
            },
          });
        },
        error: (err) => {
          console.error("Error initializing Zoom:", err);
          setError("Failed to initialize Zoom. Please try again.");
          setIsJoining(false);
        },
      });
    } catch (err) {
      console.error("Error in join process:", err);
      setError("An error occurred. Please try again.");
      setIsJoining(false);
    }
  };

  useEffect(() => {
    if (userName && !isJoined) {
      joinWebinar();
    }

    return () => {
      if (isJoined) {
        ZoomMtg.leaveMeeting({});
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userName]);

  if (error) {
    return (
      <div className="error-container">
        <div className="error-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <h3>Connection Error</h3>
        <p>{error}</p>
        <button onClick={() => joinWebinar()} className="retry-button">
          Try Again
        </button>
      </div>
    );
  }

  if (isJoining && !isJoined) {
    return (
      <div className="loading-container">
        <div className="loading-content">
          <div className="loading-spinner"></div>
          <h3>Connecting to webinar...</h3>
          <p>Please wait while we establish your connection</p>
        </div>
      </div>
    );
  }

  if (isJoined) {
    return <div className="zoom-container"></div>;
  }

  return (
    <div className="webinar-layout">
      {/* Left Column - Content */}
      <div className="content-column">
        <div className="webinar-info">
          <h2 className="webinar-title">Upcoming Webinar</h2>
          <p className="webinar-description">
            Join our exclusive webinar on the latest trends in technology and
            innovation. Learn from industry experts and get insights into the
            future of digital transformation.
          </p>

          <div className="webinar-details">
            <div className="detail-item">
              <div className="detail-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <div className="detail-text">
                Date: June 15, 2023 | 2:00 PM EST
              </div>
            </div>

            <div className="detail-item">
              <div className="detail-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              </div>
              <div className="detail-text">Duration: 60 minutes</div>
            </div>

            <div className="detail-item">
              <div className="detail-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <div className="detail-text">
                Speaker: Dr. Jane Smith, Tech Innovation Expert
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Column - Form */}
      <div className="form-column">
        <div className="join-form">
          <h3 className="form-title">Join the Webinar</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="form-label">
                Full Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className="form-input"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-input"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone" className="form-label">
                Phone Number
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                className="form-input"
                placeholder="Enter your phone number"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
            </div>

            <button type="submit" className="join-button">
              Join Webinar Now
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ZoomWebinar;
